import { string, bool, func } from 'prop-types';

export default {
  title: string.isRequired,
  open: bool.isRequired,
  onClose: func.isRequired,
  onDelete: func.isRequired
};
